import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

import { getImageUrl } from "src/Common/common";

// Confirmation modal for revoking an approved time-off request.
// Captures an optional note describing why the approval was revoked.
function RevokeDialog({ shown, technicianName, submitting, onConfirm, onCancel }) {
  const [notes, setNotes] = useState("");

  // reset the note field whenever the dialog is reopened
  useEffect(() => {
    if (shown) setNotes("");
  }, [shown]);

  if (!shown) return null;

  return (
    <div className="fixed inset-0 w-screen h-screen bg-black bg-opacity-30 flex items-center justify-center z-[60]">
      <OutsideClickHandler onOutsideClick={onCancel}>
        <div className="flex w-[420px] flex-col items-start gap-5 p-6 rounded-2xl bg-white shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)]">
          <div className="flex w-full items-start justify-between">
            <div className="w-10 h-10 rounded-full bg-[#FEF2F2] flex items-center justify-center">
              <img src={getImageUrl("/images/timeoff/red_warning.svg")} className="w-5 h-5" alt="" />
            </div>
            <button
              onClick={onCancel}
              className="p-1 text-[#94A3B8] hover:text-[#475569] focus:outline-none"
              aria-label="Close"
            >
              <FiX size={20} />
            </button>
          </div>

          <div className="w-full">
            <span className="font-OpenSansSemiBold text-[20px] font-semibold not-italic leading-6 capitalize text-[#1A2332]">
              Revoke Approved Time Off?
            </span>
            <p className="mt-2 font-OpenSansRegular text-[16px] font-normal not-italic leading-6 text-[#707580]">
              This will remove the approved time off from staffing and calendar views and return{" "}
              {technicianName || "the technician"} to available status.
            </p>
          </div>

          <div className="w-full">
            <label className="block font-OpenSansSemiBold text-[14px] font-semibold not-italic leading-5 tracking-[0.14px] capitalize text-[#1A2332]">Notes (Optional)</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
              placeholder="ex. Vacation cancelled by technician"
              className="mt-2 w-full rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] px-3 py-2.5 text-[14px] font-OpenSansRegular text-[#1E293B] placeholder:font-OpenSansRegular placeholder:not-italic placeholder:font-normal placeholder:text-[14px] placeholder:leading-5 placeholder:tracking-[0.14px] placeholder:text-[#868DA6] leading-5 resize-none focus:outline-none focus:ring-2 focus:ring-[#E2E8F0]"
            />
          </div>

          <div className="flex w-full items-center gap-3">
            <button
              onClick={onCancel}
              disabled={submitting}
              className="flex flex-1 h-10 items-center justify-center gap-2 px-4 rounded-lg border border-[#C9CEE2] bg-white shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] font-OpenSansSemiBold text-[16px] font-semibold not-italic leading-6 capitalize text-[#1A2332] disabled:opacity-50 focus:outline-none"
            >
              Cancel
            </button>
            <button
              onClick={() => onConfirm(notes.trim())}
              disabled={submitting}
              className="flex flex-1 h-10 items-center justify-center gap-2 px-4 rounded-lg bg-[#EF4444] font-OpenSansSemiBold text-[16px] font-semibold not-italic leading-6 capitalize text-white disabled:opacity-50 focus:outline-none"
            >
              Confirm Revoke
            </button>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
}

export default RevokeDialog;
